import { createContext, type MutableRefObject } from "react";

export type FormContextValue = {
  scrollContainerRef: MutableRefObject<HTMLDivElement | null>;
  hasScrolled: boolean;
  setHasScrolled: (hasScrolled: boolean) => void;
  disableToolbarAnimation: boolean;
  setDisableToolbarAnimation: (disableToolbarAnimation: boolean) => void;
};

export const FormContext = createContext<FormContextValue | null>(null);
